import each from './each';

export default function reduce(iterable, callback, memo = null) {
   each( iterable, (val, key, it) => {
      memo = callback(memo, val, key, it);
   });
   return memo;
}
